import { AutogenModelEdilocNojoins, AutogenRowEdilocNojoins } from "./autogen/AutogenModelEdilocNojoins";

export class ModelEdilocNojoins extends AutogenModelEdilocNojoins<RowEdilocNojoins> {
	constructor() {
		super(RowEdilocNojoins);
	}
}

export class RowEdilocNojoins extends AutogenRowEdilocNojoins {
}